<template>
    <div class="caseReporting">
        <div class="header">Case Report</div>
        <b-row class="content lastBy" no-gutters>
            <!-- <b-col md="6" class="pr-6">
                <div class="boxShadow">
                    <div class="content">
                        <b-button v-if="(this.Item && this.Item.officer_in_charge_id && this.Item.officer_in_charge_id == this.UserLogin.id) && !($disabledCreateOrUpdate(this.Item, $accessModule.case_management) || (Item && Item.id != 0 && ['Repeated Feedback', 'Cancelled', 'Closed'].includes(Item.status)))" class="editBox" @click="editWorkFinding">
                            <img src="img/iconPencil.png" alt="" />
                        </b-button>
                        <div class="title">Work Findings</div>
                        <b-row>
                            <b-col md="8" class="">
                                <label>description</label>
                                <div class="info-right" v-html="Item.work_finding && Item.work_finding.description ? Item.work_finding.description.replaceAll('\n', '<br>') : ''"></div>
                            </b-col>
                            <b-col md="4" class="photosThumb">
                                <gofix-text-field label="photos" oneline>
                                    <template v-if="Item.work_finding && Item.work_finding.attachments">
                                        <viewer-image :images="Item.work_finding.attachments" classViewer='d-flex align-items-center'>
                                            <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                                <ul class="list-thumb checklist">
                                                    <template v-for="(item, key) in images">
                                                        <li v-if="images.length <= 2 || key <= (images.length-2)" :class="{'d-none': key > 1}" v-bind:key="key">
                                                            <img v-auth-image="item.url.original" :alt="item.image_file_name" :key="item.url.original" src="img/loading.gif">
                                                        </li>
                                                    </template>
                                                </ul>
                                                <template v-if="images.length > 2">
                                                    <div class="attachmentsColumn cursor-pointer pl-0">
                                                        <div class="item-content bg-transparent pd-0">
                                                            <img class="image-viewer" v-auth-image="images[images.length-1].url.original"    src="img/loading.gif">
                                                            <span class="checklist-photo-custom" v-if="images.length > 2">+{{ images.length - 2 }}</span>
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>
                                        </viewer-image>
                                    </template>
                                </gofix-text-field>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </b-col>
            <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Work Findings" hide-footer :centered="true" ref="modal-edit-work-finding" @close="() => {
                this.work_finding_del_ids = [];
                this.imgWorkFindingAction.photos = [];
            }">
                <b-form class="pb-10">
                    <gofix-form-input-textarea label="Description" :rows="5" v-model="work_finding.description"></gofix-form-input-textarea>
                    <b-form-group label="photos" class="photosThumb clear-both">
                        <ul class="list-thumb">
                            <li v-for="(item,key) in work_finding.attachments" v-bind:key="key"><img v-auth-image="item.url.thumb" src="img/loading.gif" alt=""> <span class="delete" @click="deleteImgWorkFinding(item)"><img src="img/close.png" alt=""></span></li>
                        </ul>
                        <div class="upload-btn-wrapper">
                            <b-form-file accept="image/jpeg, image/png, image/gif" id="fileInputMulti" v-model="imgWorkFinding" :plain="true" :multiple="true"></b-form-file>
                            <gofix-button class="m-3" label="add photo" outline></gofix-button>
                        </div>
                    </b-form-group>
                </b-form>
                <b-button-group class="d-block text-right">
                    <gofix-button label="SUBMIT" @click="updateWorkFinding" :loading="isAction" noBorder></gofix-button>
                </b-button-group>
            </b-modal> -->
            <b-col md="6 pl-6">
                <div class="boxShadow">
                    <div class="content">
                        <b-button v-if="(this.Item && this.Item.officer_in_charge_id && this.Item.officer_in_charge_id == this.UserLogin.id) && !($disabledCreateOrUpdate(this.Item, $accessModule.case_management) || (Item && Item.id != 0 && ['Repeated Feedback', 'Cancelled', 'Closed'].includes(Item.status)))" class="editBox" @click="editActionTaken">
                            <img src="img/iconPencil.png" alt="" />
                        </b-button>
                        <div class="title">Action Taken</div>
                        <b-row>
                            <b-col md="8" class="">
                                <label>description</label>
                                <div class="info-right" v-html="Item.action_taken && Item.action_taken.description ? Item.action_taken.description.replaceAll('\n', '<br>') : ''"></div>
                            </b-col>
                            <b-col md="4" class="photosThumb">
                                <gofix-text-field label="photos" oneline>
                                    <template v-if="Item.action_taken && Item.action_taken.attachments">
                                        <viewer-image :images="Item.action_taken.attachments" classViewer='d-flex align-items-center'>
                                            <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                                <ul class="list-thumb checklist">
                                                    <template v-for="(item, key) in images">
                                                        <li v-if="images.length <= 2 || key <= (images.length-2)" :class="{'d-none': key > 1}" v-bind:key="key">
                                                            <img v-auth-image="item.url.original" :alt="item.image_file_name" :key="item.url.original"  src="img/loading.gif">
                                                        </li>
                                                    </template>
                                                </ul>
                                                <template v-if="images.length > 2">
                                                    <div class="attachmentsColumn cursor-pointer pl-0">
                                                        <div class="item-content bg-transparent pd-0">
                                                            <img class="image-viewer" v-auth-image="images[images.length-1].url.original"   src="img/loading.gif">
                                                            <span class="checklist-photo-custom" v-if="images.length > 2">+{{ images.length - 2 }}</span>
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>
                                        </viewer-image>
                                    </template>
                                </gofix-text-field>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </b-col>
            <b-modal :no-close-on-backdrop="true" id="modal-Create" title="action taken" hide-footer :centered="true" ref="modal-edit-action-taken" @close="() => {
                this.action_taken_del_ids = [];
                this.imgActionTakenAction.photos = [];
            }">
                <b-form class="pb-10">
                    <gofix-form-input-textarea label="Description" :rows="5" v-model="action_taken.description"></gofix-form-input-textarea>
                    <b-form-group label="photos" class="photosThumb clear-both">
                        <ul class="list-thumb">
                            <li v-for="(item,key) in action_taken.attachments" v-bind:key="key"><img v-auth-image="item.url.thumb" src="img/loading.gif" alt=""> <span class="delete" @click="deleteImgActionTaken(item)"><img src="img/close.png" alt=""></span></li>
                        </ul>
                        <div class="upload-btn-wrapper">
                            <b-form-file accept="image/jpeg, image/png, image/gif" id="fileInputMulti" v-model="imgActionTaken" :plain="true" :multiple="true"></b-form-file>
                            <gofix-button class="m-3" label="add photo" outline></gofix-button>
                        </div>
                    </b-form-group>
                </b-form>
                <b-button-group class="d-block text-right">
                    <!-- <gofix-button label="CANCEL" @click="$refs['modal-edit-action-taken'].hide()" noBorder dark></gofix-button> -->
                    <gofix-button label="SUBMIT" @click="updateActionTaken" :loading="isAction" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
        </b-row>
        <!-- <div v-for="value in this.Item.order" :key="value.id" class="pt-15">
            <div class="header">{{value && value.order_number}} report</div>
            <b-row class="content lastBy">  
                <b-col md="12">
                    <div class="boxShadow">
                        <div class="content">
                            <div class="title">Action Taken</div>
                            <b-row>
                                <b-col md="12" class="">
                                    <label>description</label>
                                    <div class="info-right" v-html="value && value.action_taken && value.action_taken.description ? value.action_taken.description.replaceAll('\n', '<br>') : ''"></div>
                                </b-col>
                                <b-col md="12" class="photosThumb">
                                    <gofix-text-field label="photos" oneline>
                                        <template v-if="value.action_taken && value.action_taken.attachments">
                                            <viewer-image :images="value.action_taken.attachments" classViewer='d-flex align-items-center'>
                                                <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                                    <ul class="list-thumb checklist">
                                                        <template v-for="(item, key) in images">
                                                            <li v-if="images.length <= 2 || key <= (images.length-2)" :class="{'d-none': key > 1}" v-bind:key="key">
                                                                <img v-auth-image="item.url.original" :alt="item.image_file_name" :key="item.url.original"  src="img/loading.gif">
                                                            </li>
                                                        </template>
                                                    </ul>
                                                    <template v-if="images.length > 2">
                                                        <div class="attachmentsColumn cursor-pointer pl-0">
                                                            <div class="item-content bg-transparent pd-0">
                                                                <img class="image-viewer" v-auth-image="images[images.length-1].url.original"  src="img/loading.gif">
                                                                <span class="checklist-photo-custom" v-if="images.length > 2">+{{ images.length - 2 }}</span>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </template>
                                            </viewer-image>
                                        </template>
                                    </gofix-text-field>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </b-col>
                <b-col md="12" v-if="value && value.work_findings && value.work_findings.length">
                    <div class="boxShadow">
                        <div class="content">
                            <div class="title">Work Findings</div>
                            <b-row>
                                <b-col md="4" class="pr-15  mb-10" v-for="(item, index) in value.work_findings" :key="index">
                                    <gofix-card title=" " class="h-100 pd-15" classHeader="pt-0 mb-0" classContent="mb-0 pl-0 pr-0">
                                        <b-row>
                                            <b-col md="12" class="mb-15">
                                                <gofix-text-field classLabel="min-width-auto" label="Description" oneline>
                                                    <span v-html="item.description ? item.description.replaceAll('\n', '<br>') : ''"></span>
                                                </gofix-text-field>
                                            </b-col>
                                            <b-col md="12" class="photosThumb mb-15">
                                                <gofix-text-field label="photos" oneline>
                                                    <template v-if="item.attachments">
                                                        <viewer-image :images="item.attachments" classViewer='d-flex align-items-center'>
                                                            <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                                                <ul class="list-thumb checklist">
                                                                    <template v-for="(item, key) in images">
                                                                        <li v-if="images.length <= 2 || key <= (images.length-2)" :class="{'d-none': key > 1}" v-bind:key="key">
                                                                            <img v-auth-image="item.url.original" :alt="item.image_file_name" :key="item.url.original"  src="img/loading.gif">
                                                                        </li>
                                                                    </template>
                                                                </ul>
                                                                <template v-if="images.length > 2">
                                                                    <div class="attachmentsColumn cursor-pointer pl-0">
                                                                        <div class="item-content bg-transparent pd-0">
                                                                            <img class="image-viewer" v-auth-image="images[images.length-1].url.original"   src="img/loading.gif">
                                                                            <span class="checklist-photo-custom" v-if="images.length > 2">+{{ images.length - 2 }}</span>
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </template>
                                                        </viewer-image>
                                                    </template>
                                                </gofix-text-field>
                                            </b-col>
                                        </b-row>
                                    </gofix-card>  
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div> -->
        <b-modal :no-close-on-backdrop="true" ref="modalThumb" id="modalThumb" hide-footer>
            <view-img :Imgs="attachments_show_modal"></view-img>
        </b-modal>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
const ViewerImage = () => import('../plugins/ViewerImage.vue')
const ViewImg = () => import('../plugins/ViewImg.vue')
import moment from 'moment';

export default {
    name: 'case-reporting',
    components: {
        ViewImg,
        ViewerImage
    },
    data() {
        return {
            action_taken: {
                description: '',
                remark_type: 'CaseActionTaken',
                attachments: []
            },
            imgActionTakenAction: {
                photos: [],
                delete: []
            },
            imgActionTaken: null,
            action_taken_del_ids: [],
            work_finding: {
                description: '',
                remark_type: 'CaseWorkFinding',
                attachments: []
            },
            imgWorkFindingAction: {
                photos: [],
                delete: []
            },
            imgWorkFinding: null,
            work_finding_del_ids: [],
            isAction: false,
            attachments_show_modal: []
        }
    },
    created() {},
    computed: {
        ...mapGetters({
            Item: "CaseHotButtonController/Item"
        }),
    },
    filters: {
        countCompleted(data) {
            let countItem = 0;
            for (let item of data) {
                if (item.job_status === "Completed") {
                    countItem++;
                }
            }
            return countItem;
        }
    },
    watch: {
        imgWorkFinding(val, old) {
            if (val) {
                val.forEach(file => {
                    if (file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/gif') {
                        this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                        return;
                    }
                    file.moment = moment().valueOf();
                    let data = {
                        moment: moment().valueOf(),
                        url: {
                            original: URL.createObjectURL(file),
                            medium: URL.createObjectURL(file),
                            thumb: URL.createObjectURL(file)
                        }
                    }
                    this.imgWorkFindingAction.photos.push(file);
                    this.work_finding.attachments.push(data);
                });
            }
        },
        imgActionTaken(val, old) {
            if (val) {
                val.forEach(file => {
                    if (file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/gif') {
                        this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                        return;
                    }
                    file.moment = moment().valueOf();
                    let data = {
                        moment: moment().valueOf(),
                        url: {
                            original: URL.createObjectURL(file),
                            medium: URL.createObjectURL(file),
                            thumb: URL.createObjectURL(file)
                        }
                    }
                    this.imgActionTakenAction.photos.push(file);
                    this.action_taken.attachments.push(data);
                });
            }
        },
    },
    methods: {
        modalThumb(attachments) {
            this.attachments_show_modal = []
            if (attachments) {
                this.attachments_show_modal = attachments
            }
            this.$refs['modalThumb'].show()
        },
        editWorkFinding() {
            this.isAction = false;
            let data = JSON.parse(JSON.stringify(this.Item));
            if (data.work_finding) {
                this.work_finding = data.work_finding;
            } else {
                this.work_finding.attachments = [];
                this.work_finding.description = '';
            }
            this.$refs['modal-edit-work-finding'].show()
        },
        deleteImgWorkFinding(img) {
            if (img.moment) {
                this.work_finding.attachments = this.work_finding.attachments.filter(item => item.moment != img.moment);
                this.imgWorkFindingAction.photos = this.imgWorkFindingAction.photos.filter(item => item.moment != img.moment)
            } else {
                this.work_finding_del_ids.push(img.id);
                this.work_finding.attachments = this.work_finding.attachments.filter(item => item.id != img.id);
            }
        },
        deleteImgActionTaken(img) {
            if (img.moment) {
                this.action_taken.attachments = this.action_taken.attachments.filter(item => item.moment != img.moment);
                this.imgActionTakenAction.photos = this.imgActionTakenAction.photos.filter(item => item.moment != img.moment)
            } else {
                this.action_taken_del_ids.push(img.id);
                this.action_taken.attachments = this.action_taken.attachments.filter(item => item.id != img.id);
            }
        },
        updateWorkFinding() {
            this.isAction = true;
            this.$store.dispatch("CaseHotButtonController/updateRemarksCase", { data: this.work_finding, case_id: this.Item.id, action: this.imgWorkFindingAction })
                .then(result => {
                    this.imgWorkFindingAction = {
                        photos: [],
                        delete: []
                    };

                    if (this.work_finding_del_ids.length > 0) {
                        this.$store.dispatch("CaseHotButtonController/deleteAttachments", { ids: this.work_finding_del_ids, action: 'work_finding' })
                            .then(result => {
                                this.work_finding_del_ids = [];
                            })
                    }

                    this.$alertNotification(this.$notificationV2('editing', 'case'));
                    this.$refs['modal-edit-work-finding'].hide()
                    this.getCase();
                })
        },
        updateActionTaken() {
            this.isAction = true;
            this.$store.dispatch("CaseHotButtonController/updateRemarksCase", { data: this.action_taken, case_id: this.Item.id, action: this.imgActionTakenAction })
                .then(result => {
                    this.imgActionTakenAction = {
                        photos: [],
                        delete: []
                    };

                    if (this.action_taken_del_ids.length > 0) {
                        this.$store.dispatch("CaseHotButtonController/deleteAttachments", { ids: this.action_taken_del_ids, action: 'action_taken' })
                            .then(result => {
                                this.action_taken_del_ids = [];
                            })
                    }

                    this.$alertNotification(this.$notificationV2('editing', 'case'));
                    this.$refs['modal-edit-action-taken'].hide()
                    this.getCase();
                })
        },
        editActionTaken() {
            this.isAction = false;
            let data = JSON.parse(JSON.stringify(this.Item));
            if (data.action_taken) {
                this.action_taken = data.action_taken;
            } else {
                this.action_taken.attachments = [];
                this.action_taken.description = '';
            }
            this.$refs['modal-edit-action-taken'].show()
        },
        getCase() {
            this.$store.dispatch('CaseHotButtonController/getCase', { case_id: this.$route.params.id })
        },
    }
}
</script>